const Property = {
  INDEFINITE_PAUSE_TIME: '3000-01-01T00:00:00.000000Z',
};

export default Property;
